import {
  ArrowUpRight,
  Monitor,
  ShieldCheck,
  Terminal,
  Layers,
  Check,
  LockKeyhole,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from '../i18n/Link'
export default function FeaturesSection() {
  const { t } = useTranslation('home')
  return (
    <section
      className="features-section page-width"
      aria-labelledby="features-title"
    >
      <div className="section-heading">
        <div>
          <div className="eyebrow">{t('features.eyebrow')}</div>
          <h2 id="features-title">
            {t('features.title1')}
            <br />
            <span>{t('features.titleAccent')}</span>
          </h2>
        </div>
        <div>
          <p>
            {t('features.desc1')}
            <br />
            {t('features.desc2')}
          </p>
          <Link className="text-link" to="/features">
            {t('features.allFeatures')} <ArrowUpRight size={17} />
          </Link>
        </div>
      </div>
      <div className="feature-bento">
        <Link to="/features" className="bento-card remote-card">
          <span className="card-icon">
            <Monitor />
          </span>
          <div>
            <span className="card-index">{t('features.remote.index')}</span>
            <h3>{t('features.remote.title')}</h3>
            <p>{t('features.remote.text')}</p>
          </div>
          <div className="connection-art" aria-hidden="true">
            <span>
              <Monitor size={28} />
              <small>{t('features.remote.yourDevice')}</small>
            </span>
            <i />
            <div>
              <Check size={20} />
            </div>
            <i />
            <span>
              <Monitor size={28} />
              <small>{t('features.remote.yourWorkspace')}</small>
            </span>
          </div>
          <ArrowUpRight className="card-arrow" />
        </Link>
        <Link to="/security" className="bento-card security-card">
          <span className="card-icon">
            <ShieldCheck />
          </span>
          <span className="card-index">{t('features.security.index')}</span>
          <h3>
            {t('features.security.title1')}
            <br />
            {t('features.security.title2')}
          </h3>
          <p>{t('features.security.text')}</p>
          <div className="security-emblem" aria-hidden="true">
            <div>
              <LockKeyhole size={34} />
            </div>
          </div>
          <ArrowUpRight className="card-arrow" />
        </Link>
        <Link to="/enterprise" className="bento-card terminal-card">
          <span className="card-icon">
            <Terminal />
          </span>
          <span className="card-index">{t('features.terminal.index')}</span>
          <h3>
            {t('features.terminal.title1')}
            <br />
            {t('features.terminal.title2')}
          </h3>
          <p>{t('features.terminal.text')}</p>
          <div className="code-snippet" aria-hidden="true">
            <span>~/workspace</span>
            <br />
            <b>→</b> connect your possibilities
            <span className="code-cursor">▌</span>
          </div>
          <ArrowUpRight className="card-arrow" />
        </Link>
      </div>
      <div className="feature-note">
        <Layers size={16} />
        <span>{t('features.note')}</span>
        <Link to="/pricing">
          {t('features.findPlan')} <ArrowUpRight size={15} />
        </Link>
      </div>
    </section>
  )
}
